export enum PAGE_TYPE {
    Home,
    About,
    Art,
    Train,
    Resource,
    Member,
}